var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRoundX = function SvgRoundX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "fill",
    fill: "currentColor",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M39.378 19.983c1.071 1.071 1.01 2.87-.138 4.018l-5.68 5.68 5.68 5.68c1.105 1.105 1.203 2.814.252 3.895l-.114.122c-1.071 1.071-2.87 1.01-4.017-.138l-5.68-5.68L24 39.24c-1.105 1.105-2.814 1.203-3.896.252l-.122-.114c-1.071-1.071-1.009-2.87.139-4.017l5.68-5.68-5.68-5.68c-1.105-1.105-1.204-2.814-.253-3.896l.114-.122c1.071-1.071 2.87-1.009 4.018.139l5.68 5.68 5.68-5.68c1.105-1.105 2.814-1.204 3.895-.253z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoundX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roundX.bd58766d.svg";
export { ForwardRef as ReactComponent };